import { useState } from 'react';
import { Badge, Box, Button, Chip, Dropdown, IconButton, Menu, MenuButton, Stack, Typography } from '@mui/joy';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

import { useAdvertiser } from '../../AdvertiserContext';
import { APIAdsNotifications, APIAdsNotificationsRead } from '../../api_ads';

const SEV = { info: 'neutral', warning: 'warning', critical: 'danger' };

export default function AdNotificationsBell() {
    const { advertiserToken: token } = useAdvertiser();
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [unread, setUnread] = useState(0);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        if (!token) return;
        setLoading(true);
        try {
            const r = await APIAdsNotifications(token, { pageSize: 20 });
            setItems(r?.items || []);
            setUnread(r?.unread || 0);
        } catch (e) { /* тихо */ } finally { setLoading(false); }
    };

    const markAll = async () => {
        try {
            await APIAdsNotificationsRead(token, { all: true });
            setUnread(0);
            setItems((prev) => prev.map((n) => ({ ...n, is_read: true })));
        } catch (e) { /* тихо */ }
    };

    return (
        <Dropdown open={open} onOpenChange={(_, o) => { setOpen(o); if (o) load(); }}>
            <MenuButton slots={{ root: IconButton }}
                        slotProps={{ root: { variant: 'soft', color: 'neutral' } }}>
                <Badge badgeContent={unread} color="danger" invisible={!unread}>
                    <NotificationsRoundedIcon />
                </Badge>
            </MenuButton>
            <Menu placement="bottom-end" sx={{ width: 340, maxHeight: 440, overflow: 'auto', p: 1 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 1, py: 0.5 }}>
                    <Typography level="title-sm">Уведомления</Typography>
                    {unread > 0 && <Button size="sm" variant="plain" onClick={markAll}>Прочитать все</Button>}
                </Stack>
                {loading && (
                    <Typography level="body-sm" color="neutral" sx={{ px: 1, py: 1 }}>Загрузка…</Typography>
                )}
                {!loading && items.length === 0 && (
                    <Typography level="body-sm" color="neutral" sx={{ px: 1, py: 2, textAlign: 'center' }}>
                        Пока пусто
                    </Typography>
                )}
                {items.map((n) => (
                    <Box key={n.id} sx={{
                        px: 1, py: 1, mb: 0.5, borderRadius: 'sm',
                        bgcolor: n.is_read ? 'transparent' : 'primary.softBg',
                    }}>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.3 }}>
                            <Chip size="sm" color={SEV[n.severity] || 'neutral'} variant="soft">{n.kind}</Chip>
                            <Typography level="body-sm" sx={{ fontWeight: 600 }}>{n.title}</Typography>
                        </Stack>
                        {n.body && <Typography level="body-xs" color="neutral">{n.body}</Typography>}
                        <Typography level="body-xs" color="neutral" sx={{ mt: 0.3 }}>
                            {n.date_create ? format(new Date(n.date_create), 'd MMM HH:mm', { locale: ru }) : ''}
                        </Typography>
                    </Box>
                ))}
            </Menu>
        </Dropdown>
    );
}